export default {
  SET_CABECALHO(state, payload) {
    state.cabecalho = payload;
  },
  SET_INVOICES(state, payload) {
    state.invoicesCompletas = payload;
  },
  CLEAN_INVOICES(state, payload) {
    state.invoicesCompletas = payload;
  },
};
